import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

export const StyledItemSaveContainer = styled(ItemSaveContainer)`
    @media print {
        display: none;
    }
`;

interface PrintContainerProps {
    noWidthLimit: boolean;
}

export const StyledPrintContainer = styled.div<PrintContainerProps>`
    ${({ noWidthLimit }) => (noWidthLimit ? 'width: fit-content;' : '')}

    @media print {
        display: flex;
        flex-direction: row;
    }
`;

export const TitleMenuWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TriggerWrapper = styled.span`
    display: flex;
    justify-content: center;
    width: 15px;
    height: 24px;
    cursor: pointer;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
    font-size: 24px;
    display: none;

    /* stylelint-disable */
    ${StyledPrintContainer}:hover & {
        display: inline-block;
    }
    /* stylelint-enable */

    &:hover {
        color: ${({ theme }) => theme.colors.blue200};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        display: inline-block;
    }
`;

export const StyledLink = styled(Link)`
    width: 100%;

    && {
        text-decoration: none;
    }
`;

export const PopoverWrapper = styled.span`
    padding-left: 3px;

    > div {
        display: inline-block;
    }
`;

export const StyledPopover = styled(Popover)`
    max-width: 300px;
    z-index: 13;
`;

export const PopoverContentContainer = styled.div`
    padding: 5px 0;
`;

export const PopoverMenuItem = styled.div`
    font-size: 14px;
    line-height: 20px;
    text-align: flex-start;
    letter-spacing: 0.5px;
    cursor: pointer;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;

    :hover {
        background-color: ${({ theme }) => theme.colors.grey500};
    }
`;

export const StyledSubMenuText = styled(Text)`
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
`;
